var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var modalForm = require('../layout/components/modalForm');
var heading = require('../components/heading');
var Model = require('../libs/Model');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');
var alarmProfile = Object.assign(require('../../../../models/alarms/AlarmProfile'), Model);
modalForm(alarmProfile)

var component = {};

component.oninit = function (vnode) {
  var ctrl = vnode.state;
  document.title = 'nimrod | Alarm Profiles';
  header.vm.activeTab('Alarm Profiles');
  ctrl.newNode = prop(false);

  ctrl.init = function () {
    return loaders.requestWithLoader({
      url: "/api/v1/alarmprofile/",
      method: "GET"
    })
    .then(function(result){
      ctrl.pointProfiles = result;
      ctrl.newNode(true);
      m.redraw()
    });
  }

  ctrl.pointProfilesToShow = [];

  ctrl.init();
}


component.view = function (vnode) {
  var ctrl = vnode.state
  if (!ctrl.pointProfiles) {
    return m('div')
  }
  return m('div.mh3', [
    m(heading,{label:'Alarm Profiles', class:'f-subheadline mb3 pb1 display'},[
      edit.vm.editing() ? m(rowActionDropdown, {
        items: [
          {
            label: 'Add Alarm Profile',
            icon: 'ion-plus',
            onclick: m.route.set.bind(m, '/alarmprofile/new')
          }
        ]
      }) : ''
    ]),
    m(paginationWithSearch, {
      data: ctrl.pointProfiles,
      newNode: ctrl.newNode,
      dataToShow: ctrl.pointProfilesToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name'],
    },[
      m('table.w-100.f4.mb5.pt3', [
        m('thead', [
          m('tr', [
            m('th.ph0.tl', 'Name'),
            m('th.ph0.tl.ph2', 'Actions')
          ])
        ]),
        m('tbody', [
          ctrl.pointProfilesToShow.map(function (record) {
            if (!record['@rid']) {
              return m('tr', [
                m('td.tl.pv0.nowrap',[
                  m('label',{style:{'visibility':'hidden'}}, 'No Data')
                ]),
                m('td.tl.pv0.nowrap', [
                  m('div', { style: { visibility: 'hidden' } }, [
                    m(rowActionDropdown, { items: [] })
                  ])
                ])
              ]);
            } else {
              return m('tr', [
                m('td.tl', record.name),
                m('td', [
                  m(rowActionDropdown, {
                    items: [
                      {
                        label: 'Edit',
                        icon: 'ion-ios-compose',
                        onclick: m.route.set.bind(null, '/alarmprofile/' + record['@rid'].slice(1))
                      },
                      {
                        label: 'Delete',
                        icon: 'ion-ios-trash',
                        class: 'red',
                        onclick: alarmProfile.deleteDialogue.bind(alarmProfile, record, {dashboardCallback: ctrl.init})
                      }
                    ]
                  })
                ])
              ]);
            }
          })
        ])
      ])
    ])
  ])
 }

 module.exports = component;
